import React from 'react'
import Query from '../Popup_Query/Query'

const Blogs = () => {
  return (
    <div>


<div class="">


<div class="preloader"><div class="custom-loader"></div></div>





{/* <div class="form-back-drop"></div>


<section class="hidden-bar">
    <div class="inner-box text-center">
        <div class="cross-icon"><span class="fa fa-times"></span></div>
        <div class="title">
            <h4>Get Appointment</h4>
        </div>

        <div class="appointment-form">
            <form method="post" action="/Contact">
                <div class="form-group">
                    <input type="text" name="text" value="" placeholder="Name" required/>
                </div>
                <div class="form-group">
                    <input type="email" name="email" value="" placeholder="Email Address" required/>
                </div>
                <div class="form-group">
                    <textarea placeholder="Message" rows="5"></textarea>
                </div>
                <div class="form-group">
                    <button type="submit" class="theme-btn style-two">
                        <span data-hover="Submit now">Submit now</span>
                        <i class="fal fa-arrow-right"></i>
                    </button>
                </div>
            </form>
        </div>

 
        <div class="social-style-one">
            <a href="/Contact"><i class="fab fa-twitter"></i></a>
            <a href="/Contact"><i class="fab fa-facebook-f"></i></a>
            <a href="/Contact"><i class="fab fa-instagram"></i></a>
            <a href="#"><i class="fab fa-pinterest-p"></i></a>
        </div>
    </div>
</section> */}

<Query/>

<section class="page-banner-area pt-50 pb-35 rel z-1 bgs-cover" style={{backgroundImage:"url('https://toplistsites.com/wp-content/uploads/2023/06/best-travel-blogs.jpg')"}}>
    <div class="container">
        <div class="banner-inner text-white">
            <h2 class="page-title mb-10" data-aos="fade-left" data-aos-duration="1500" data-aos-offset="50">Blog List View</h2>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb justify-content-center mb-20" data-aos="fade-right" data-aos-delay="200" data-aos-duration="1500" data-aos-offset="50">
                    <li class="breadcrumb-item"><a href="/">Home</a></li>
                    <li class="breadcrumb-item active">Blog List</li>
                </ol>
            </nav>
        </div>
    </div>
</section>

<section class="blog-list-page py-100 rel z-1">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="blog-item style-three" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                    <div class="image">
                        <img src="https://images.pexels.com/photos/2265876/pexels-photo-2265876.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Blog List"/>
                    </div>
                    <div class="content">
                        <a href="blog.html" class="category">Travel</a>
                        <h5><a href="/Blogs_Details">Ultimate Guide to Planning Your Dream Vacation</a></h5>
                        <ul class="blog-meta">
                            <li><i class="far fa-calendar-alt"></i> <a href="#">25 February 2024</a></li>
                            <li><i class="far fa-comments"></i> <a href="#">Comments (5)</a></li>
                        </ul>
                        <p>We specialize in crafting unforgettable city experiences for travelers seeking</p>
                        <a href="/Blogs_Details" class="theme-btn style-two style-three">
                            <span data-hover="Book Now">Read More</span>
                            <i class="fal fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="blog-item style-three" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                    <div class="image">
                        <img src="https://images.pexels.com/photos/2178175/pexels-photo-2178175.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Blog List"/>
                    </div>
                    <div class="content">
                        <a href="blog.html" class="category">Travel</a>
                        <h5><a href="/Blogs_Details">Ultimate Guide to Planning Your Dream Vacation</a></h5>
                        <ul class="blog-meta">
                            <li><i class="far fa-calendar-alt"></i> <a href="#">25 February 2024</a></li>
                            <li><i class="far fa-comments"></i> <a href="#">Comments (5)</a></li>
                        </ul>
                        <p>We specialize in crafting unforgettable city experiences for travelers seeking</p>
                        <a href="/Blogs_Details" class="theme-btn style-two style-three">
                            <span data-hover="Book Now">Read More</span>
                            <i class="fal fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="blog-item style-three" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                    <div class="image">
                        <img src="https://images.pexels.com/photos/2104044/pexels-photo-2104044.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Blog List"/>
                    </div>
                    <div class="content">
                        <a href="blog.html" class="category">Travel</a>
                        <h5><a href="/Blogs_Details">Ultimate Guide to Planning Your Dream Vacation</a></h5>
                        <ul class="blog-meta">
                            <li><i class="far fa-calendar-alt"></i> <a href="#">25 February 2024</a></li>
                            <li><i class="far fa-comments"></i> <a href="#">Comments (5)</a></li>
                        </ul>
                        <p>We specialize in crafting unforgettable city experiences for travelers seeking</p>
                        <a href="/Blogs_Details" class="theme-btn style-two style-three">
                            <span data-hover="Book Now">Read More</span>
                            <i class="fal fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="blog-item style-three" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                    <div class="image">
                        <img src="https://images.pexels.com/photos/2166559/pexels-photo-2166559.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Blog List"/>
                    </div>
                    <div class="content">
                        <a href="blog.html" class="category">Travel</a>
                        <h5><a href="/Blogs_Details">Ultimate Guide to Planning Your Dream Vacation</a></h5>
                        <ul class="blog-meta">
                            <li><i class="far fa-calendar-alt"></i> <a href="#">25 February 2024</a></li>
                            <li><i class="far fa-comments"></i> <a href="#">Comments (5)</a></li>
                        </ul>
                        <p>We specialize in crafting unforgettable city experiences for travelers seeking</p>
                        <a href="/Blogs_Details" class="theme-btn style-two style-three">
                            <span data-hover="Book Now">Read More</span>
                            <i class="fal fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="blog-item style-three" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                    <div class="image">
                        <img src="https://images.pexels.com/photos/13138057/pexels-photo-13138057.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Blog List"/>
                    </div>
                    <div class="content">
                        <a href="blog.html" class="category">Travel</a>
                        <h5><a href="/Blogs_Details">Ultimate Guide to Planning Your Dream Vacation</a></h5>
                        <ul class="blog-meta">
                            <li><i class="far fa-calendar-alt"></i> <a href="#">25 February 2024</a></li>
                            <li><i class="far fa-comments"></i> <a href="#">Comments (5)</a></li>
                        </ul>
                        <p>We specialize in crafting unforgettable city experiences for travelers seeking</p>
                        <a href="/Blogs_Details" class="theme-btn style-two style-three">
                            <span data-hover="Book Now">Read More</span>
                            <i class="fal fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                
      
            </div>
            <div class="col-lg-4 col-md-8 col-sm-10 rmt-75">
                <div class="blog-sidebar">
                    
                
       
                    
                    <div class="widget widget-news" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                        <h5 class="widget-title work">Recent News</h5>
                        <ul>
                            <li>
                                <div class="image">
                                    <img src="https://wallpaperaccess.com/full/4190081.jpg" alt="News"/>
                                </div>
                                <div class="content">
                                    <h6><a href="/Blogs_Details" style={{color:'white'}}>Unique Destinations an tolded Stories ways</a></h6>
                                    <span class="date work"><i class="far fa-calendar-alt"></i> 25 Feb 2024</span>
                                </div>
                            </li>
                            <li>
                                <div class="image">
                                    <img src="https://www.venuereport.com/media/cache/resolve/venue_roundup_single_image/uploads/+0Regular_Roundup/MayRoundUp/Greece_GypseaLust05.jpg" alt="News"/>
                                </div>
                                <div class="content">
                                    <h6><a href="/Blogs_Details" style={{color:'white'}}>Immersive Experiences from Around Globe</a></h6>
                                    <span class="date work"><i class="far fa-calendar-alt"></i> 25 Feb 2024</span>
                                </div>
                            </li>
                            <li>
                                <div class="image">
                                    <img src="https://media.cntraveler.com/photos/56556bab659c4b487486611e/master/pass/oia-santorini-greece-cr-alamy.jpg" alt="News"/>
                                </div>
                                <div class="content">
                                    <h6><a href="/Blogs_Details" style={{color:'white'}}>Journey to Inspire Your Next Adventure</a></h6>
                                    <span class="date work"><i class="far fa-calendar-alt"></i> 25 Feb 2024</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    
             
                    
                    <div class="widget widget-cta" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                        <div class="content text-white">
                            <span class="h6">Explore The World</span>
                            <h3>Best Tourist Place</h3>
                            <a href="/" class="theme-btn style-two bgc-secondary">
                                <span data-hover="Explore Now">Explore Now</span>
                                <i class="fal fa-arrow-right"></i>
                            </a>
                        </div>
                        <div class="image">
                            <img src="https://images.pexels.com/photos/7236024/pexels-photo-7236024.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="CTA"/>
                        </div>
                        <div class="cta-shape"><img src="assets/images/widgets/cta-shape.png" alt="Shape"/></div>
                    </div>
                    
                </div>
                
            </div>
        </div>
    </div>
</section>

]]


</div>




      
    </div>
  )
}

export default Blogs
